"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _TabContext = require("../contexts/TabContext");
var _AuthContext = require("../contexts/AuthContext");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _apis = require("../../../@apis");
var _hooks = require("../../../@hooks");
var _functions = require("../../../@functions");
var _TextInput = _interopRequireDefault(require("../../../@custom/TextInput"));
var _Icon = _interopRequireDefault(require("../../../@custom/Icon"));
var _SimpleButton = _interopRequireDefault(require("../../../@custom/SimpleButton"));
var _InboxRequest = _interopRequireDefault(require("../../../@custom/InboxRequest"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * @typedef RedefinePasswordProps
 * @type {{
 *     recoveryToken?: string;
 *     email?: string;
 *     oldPassword?: string;
 * }}
 */
/**
 * @param {RedefinePasswordProps} props
 * @returns {JSX.Element}
 */
function RedefinePassword(_ref) {
  var _errorMsgs$newPasswor, _errorMsgs$confirmPas;
  var recoveryToken = _ref.recoveryToken,
    email = _ref.email,
    oldPassword = _ref.oldPassword;
  var _useAuth = (0, _AuthContext.useAuth)(),
    showSpinner = _useAuth.showSpinner,
    showMessage = _useAuth.showMessage,
    hideSpinner = _useAuth.hideSpinner;
  var _useContext = (0, _react.useContext)(_TabContext.TabContext),
    setTab = _useContext.setTab;
  var _useErrors = (0, _hooks.useErrors)(),
    disabled = _useErrors.disabled,
    errorMsgs = _useErrors.errorMsgs,
    addErrorMsg = _useErrors.addErrorMsg,
    removeErrorMsg = _useErrors.removeErrorMsg;
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    newPassword = _useState2[0],
    setNewPassword = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    confirmPassword = _useState4[0],
    setConfirmPassword = _useState4[1];

  /** @param {React.ChangeEvent<HTMLInputElement>} evt */
  var handleNewPasswordChange = function handleNewPasswordChange(evt) {
    var newPwd = evt.target.value;
    setNewPassword(newPwd);
    if (!newPwd) addErrorMsg('newPassword', 'new-password-missing');else removeErrorMsg('newPassword', 'new-password-missing');
  };

  /** @param {React.ChangeEvent<HTMLInputElement>} evt */
  var handleConfirmPasswordChange = function handleConfirmPasswordChange(evt) {
    var newConfirmPassword = evt.target.value;
    setConfirmPassword(newConfirmPassword);
    if (newConfirmPassword !== newPassword) addErrorMsg('confirmPassword', 'wrong-confirm-newPassword');else removeErrorMsg('confirmPassword', 'wrong-confirm-newPassword');
  };
  var handleRedefinePassword = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (newPassword) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return", addErrorMsg('newPassword', 'new-password-missing'));
          case 4:
            removeErrorMsg('newPassword', 'new-password-missing');
          case 5:
            if (!(confirmPassword !== newPassword)) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", addErrorMsg('confirmPassword', 'wrong-confirm-newPassword'));
          case 9:
            removeErrorMsg('confirmPassword', 'wrong-confirm-newPassword');
          case 10:
            showSpinner();
            _context.prev = 11;
            if (!recoveryToken) {
              _context.next = 17;
              break;
            }
            _context.next = 15;
            return _apis.appcenterApi.auth.changePasswordWithRecoveryToken(recoveryToken, newPassword);
          case 15:
            _context.next = 20;
            break;
          case 17:
            if (!(_functions.validator.email(email) && oldPassword)) {
              _context.next = 20;
              break;
            }
            _context.next = 20;
            return _apis.appcenterApi.auth.changePassword(email, oldPassword, newPassword);
          case 20:
            setTab('login');
            _context.next = 26;
            break;
          case 23:
            _context.prev = 23;
            _context.t0 = _context["catch"](11);
            showMessage('Erro ao alterar a senha', /*#__PURE__*/_react["default"].createElement(_InboxRequest["default"], {
              error: _context.t0,
              additionalInfo: {
                email: email,
                recoveryToken: recoveryToken,
                newPassword: newPassword,
                oldPassword: oldPassword
              }
            }));
          case 26:
            _context.prev = 26;
            hideSpinner();
            return _context.finish(26);
          case 29:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[11, 23, 26, 29]]);
    }));
    return function handleRedefinePassword() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Auth-right-form"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Auth-right-form-textBox"
  }, /*#__PURE__*/_react["default"].createElement("h1", null, "Redefinir senha"), /*#__PURE__*/_react["default"].createElement("p", null, "Mantenha sua conta a salvo!"), /*#__PURE__*/_react["default"].createElement("p", null, "Configure uma nova senha")), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Nova Senha",
    placeholder: "1234",
    onChange: handleNewPasswordChange,
    value: newPassword,
    isPassword: true
  }), ((_errorMsgs$newPasswor = errorMsgs.newPassword) === null || _errorMsgs$newPasswor === void 0 ? void 0 : _errorMsgs$newPasswor.length) > 0 && errorMsgs.newPassword.map(function (msg) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: msg,
      className: "Auth-right-form-error"
    }, "* ", errors[msg]);
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Confirme a senha",
    placeholder: "1234",
    onChange: handleConfirmPasswordChange,
    value: confirmPassword,
    isPassword: true
  }), ((_errorMsgs$confirmPas = errorMsgs.confirmPassword) === null || _errorMsgs$confirmPas === void 0 ? void 0 : _errorMsgs$confirmPas.length) > 0 && errorMsgs.confirmPassword.map(function (msg) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: msg,
      className: "Auth-right-form-error"
    }, "* ", errors[msg]);
  }), /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    fullWidth: true,
    onClick: handleRedefinePassword,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Redefinir nova senha"), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faUserPlus"
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: "Auth-right-form-centeredText"
  }, "N\xE3o \xE9 aqui?", ' ', /*#__PURE__*/_react["default"].createElement("span", {
    className: "Auth-right-form-link",
    onClick: function onClick() {
      return setTab('login');
    }
  }, "Voltar \xE0 tela de login")));
}
RedefinePassword.propTypes = {
  recoveryToken: _propTypes["default"].string,
  email: _propTypes["default"].string,
  oldPassword: _propTypes["default"].string
};
var _default = RedefinePassword;
exports["default"] = _default;
var errors = {
  'new-password-missing': 'A senha é obrigatória',
  'wrong-confirm-newPassword': 'O campo "Confirme a senha" precisa ser igual à senha'
};